import { render, staticRenderFns } from "./emailLineElementEditor.vue?vue&type=template&id=44024db5&scoped=true&"
import script from "./emailLineElementEditor.vue?vue&type=script&lang=js&"
export * from "./emailLineElementEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44024db5",
  null
  
)

export default component.exports